import { render, staticRenderFns } from "./blogArchives.vue?vue&type=template&id=2d9419dd"
import script from "./blogArchives.vue?vue&type=script&lang=js"
export * from "./blogArchives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports